import { createAsyncThunk } from "@reduxjs/toolkit";

import { RootState } from "../../../app/store";
import {
  BranchDetails,
  BranchDetailsAPI,
  UpsertBranchDetailsRequest,
} from "../../../api/branchDetails";
import { MessageResponse } from "../../../api/common";

export const fetchBranchDetails = createAsyncThunk<
  BranchDetails[],
  string[],
  { state: RootState }
>(
  "branchDetails/fetchBranchDetails",
  async (branchIds, { getState }) => {
    const missingBranchIds = branchIds.filter(
      (id) => !getState().branchDetails.entities[id],
    );

    const response = await BranchDetailsAPI.get(missingBranchIds);
    return response.branch_details;
  },
  {
    condition: (branchIds, { getState }) =>
      branchIds.some((id) => !getState().branchDetails.entities[id]),
  },
);

export const upsertBranchDetails = createAsyncThunk<
  MessageResponse,
  UpsertBranchDetailsRequest
>("branchDetails/upsertBranchDetails", async (request) => {
  return await BranchDetailsAPI.upsert(request);
});